import {HttpClient} from '@angular/common/http';
import {first, Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {getDefaultHttpHeaders} from '../utils/http-headers.utils';
import {Injectable} from '@angular/core';
import {ICompanySearchSuggestion, IPappersDetailedInformations} from '@models/pappers.interface';

@Injectable({
  providedIn: 'root',
})
export class PappersService {
  BASE_URL = "/pappers";

  constructor(private http: HttpClient) {
  }

  findCompanyBySiret(siret: string): Observable<IPappersDetailedInformations> {
    return this.http.post<IPappersDetailedInformations>(`${environment.apiUrl}${this.BASE_URL}/${siret}`, {headers: getDefaultHttpHeaders().headers}).pipe(first());
  }

  searchCompanies(query: string, precise: boolean): Observable<ICompanySearchSuggestion[]> {
    return this.http.get<ICompanySearchSuggestion[]>(
      `${environment.apiUrl}${this.BASE_URL}/search`,
      {
        params: {q: query, precise: precise},
        headers: getDefaultHttpHeaders().headers
      }
    ).pipe(first());
  }
}
